import { EVENTS } from "./analytics.constants";

export type FormEventPayload = {
  formName: string;
  formLocation: string;
  formId: string;
  formMarketingName: string;
  formType: string;
  fieldName?: string;
  errorCode?: string;
};

export const FORM_EVENTS = {
  FOOTER_EMAIL: {
    event: EVENTS.FORM_SUBMIT_ATTEMPT,
    formEvent: {
      formName: "email_capture",
      formLocation: "footer",
      formId: "email-form-id",
      formMarketingName: "email_capture_ribbon_footer",
      formType: "single-step",
    },
  },
  HEADER_EMAIL: {
    event: EVENTS.FORM_SUBMIT_ATTEMPT,
    formEvent: {
      formName: "email_capture",
      formLocation: "top",
      formId: "email-form-id",
      formMarketingName: "email_capture_ribbon_header",
      formType: "single-step",
    },
  },
  SAVE_SYSTEM: {
    event: EVENTS.FORM_SUBMIT_ATTEMPT,
    formEvent: {
      formName: "email_capture",
      formLocation: "main",
      formId: "email-form-id",
      formMarketingName: "email_capture_save_system",
      formType: "single-step",
    },
  },
  SAVE_CART: {
    event: EVENTS.FORM_SUBMIT_ATTEMPT,
    formEvent: {
      formName: "email_capture",
      formLocation: "main",
      formId: "email-form-id",
      formMarketingName: "email_capture_save_cart",
      formType: "single-step",
    },
  },
  CUSTOMER_INFO: {
    event: EVENTS.FORM_SUBMIT_ATTEMPT,
    formEvent: {
      formName: "customerinfo_form",
      formLocation: "checkout",
      formId: "form_field",
      formMarketingName: "customerinfo_form",
      formType: "form_field",
    },
  },
  QUIZ_EMAIL: {
    event: EVENTS.FORM_SUBMIT_ATTEMPT,
    formEvent: {
      formName: "email_capture",
      formLocation: "main",
      formId: "quiz-email-form-id",
      formMarketingName: "quiz_email_capture",
      formType: "single-step",
    },
  },
  HEADER_FLYOUT: {
    event: EVENTS.FORM_SUBMIT_ATTEMPT,
    formEvent: {
      formName: "single-step quote",
      formLocation: "main",
      formId: "adt-header-form-id",
      formMarketingName: "flyout form",
      formType: "single-step",
      fieldName: "Postal_Code",
    },
  },
  HORIZONTAL_QUOTE: {
    event: EVENTS.FORM_SUBMIT_ATTEMPT,
    formEvent: {
      formName: "single-step quote",
      formLocation: "main",
      formId: "adt-new-horz-form-id",
      formMarketingName: "horizontal expanded form",
      formType: "single-step",
      fieldName: "Postal_Code",
    },
  },
} as const;

export type CustomerIntent = "pro" | "diy" | "unsure";

/** Accepts the default ids and the ids the Sanity schema suggests to editors. */
export const toCustomerIntent = (
  installPreference?: string,
): CustomerIntent | undefined => {
  switch (installPreference) {
    case "difm":
    case "pro":
      return "pro";
    case "diy":
      return "diy";
    case "difm_diy":
    case "not_sure":
      return "unsure";
    default:
      return undefined;
  }
};
